import { Field, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
@InputType('StripeBankTransferInfoInput')
export class StripeBankTransferInfo {
  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  bankName?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  routingNumber?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  accountNumber?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  swiftCode?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  email?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String, required: false })
  reference?: string
}
